// Attendance and generated Actuals scroll inside the shell, retaining their frozen headers.
export const eventWorkspaceUsesShellScroller = (activeTab: string) =>
  activeTab === 'dashboard' || activeTab === '7' || activeTab === '0' || activeTab === '2' || activeTab === '4' || activeTab === '5';

export const eventWorkspaceUsesConstrainedPanel = (activeTab: string) =>
  activeTab === '6';

export const eventWorkspaceFrameSx = (activeTab: string) => {
  const usesConstrainedPanel = eventWorkspaceUsesConstrainedPanel(activeTab);
  const usesViewportBoundedScroller = eventWorkspaceUsesShellScroller(activeTab);

  return {
    width: '100%',
    height: '100%',
    // The outer shell has only a minimum viewport height. Bound the editable
    // shell-scrolled tabs so wheel events reach a real scroll range.
    maxHeight: usesViewportBoundedScroller
      ? 'calc(100dvh - 82px)'
      : undefined,
    minHeight: 0,
    minWidth: 0,
    display: usesConstrainedPanel ? 'flex' : undefined,
    flexDirection: usesConstrainedPanel ? 'column' : undefined,
    typography: 'body1',
    overflowX: 'hidden',
    overflowY: eventWorkspaceUsesShellScroller(activeTab) ? 'auto' : 'hidden',
    overscrollBehaviorY: eventWorkspaceUsesShellScroller(activeTab)
      ? 'contain'
      : undefined
  };
};
import { useLayoutEffect, useRef } from 'react';

export const useEventWorkspaceScrollReset = (activeTab: string) => {
  const frameRef = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    // Hidden-overflow tabs must not inherit a scrolled Quote/Dashboard frame.
    if (frameRef.current) frameRef.current.scrollTop = 0;
  }, [activeTab]);
  return frameRef;
};
